export enum MandatorParameterTypes {
  BOOL = 'BOOL',
  TEXT = 'TEXT',
  EMPTY = ''
} 